/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_O2Inputs */

const en_mk_sol_agensi_o2 = /** @type {(inputs: Mk_Sol_Agensi_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A first draft exists before anyone sits down to write one`)
};

const id_mk_sol_agensi_o2 = /** @type {(inputs: Mk_Sol_Agensi_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf pertama sudah ada sebelum orang duduk mengerjakannya`)
};

/**
* | output |
* | --- |
* | "A first draft exists before anyone sits down to write one" |
*
* @param {Mk_Sol_Agensi_O2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_o2 = /** @type {((inputs?: Mk_Sol_Agensi_O2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_O2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_o2(inputs)
	return en_mk_sol_agensi_o2(inputs)
});